import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import updateFolderCountsInStore from '../actions/updateFolderCountsInStore';
import { lazySubscribe, NotificationSubscription } from 'owa-notification';

function onHierarchyNotificationCallback(notification: NotificationPayloadBase) {
    switch (notification.EventType) {
        case 'RowAdded':
        case 'RowModified':
            const hierarchyNotification: HierarchyNotificationPayload = notification;
            updateFolderCountsInStore(
                hierarchyNotification.unreadCount,
                hierarchyNotification.itemCount,
                hierarchyNotification.folderId,
                false /* isDeltaChange */
            );
            break;
        default:
            return;
    }
}

export default function subscribeToHierarchyNotification(): void {
    const subscription: NotificationSubscription = {
        subscriptionId: 'HierarchyNotification',
        requiresExplicitSubscribe: true,
        subscriptionParameters: {
            NotificationType: 'HierarchyNotification',
        },
    };

    lazySubscribe.importAndExecute(subscription, onHierarchyNotificationCallback);
}
